module.exports = __webpack_public_path__ + "static/Sonyax55-99ac6497b7b44ccaa790b4f85481a4e2.png";